module.exports = __webpack_public_path__ + "static/media/05 Generali Ubezpieczenie upraw OWU.7bbb4be0.pdf";